import React, { FC, useEffect } from "react";
import { Box, Container } from "@radix-ui/themes";
import "./Badge.css";

interface BadgeProps { }

const Badge: FC<BadgeProps> = () => {
  return (
    <Box className="Badge" data-testid="Badge">
      <Container className="BadgeContainer">
        <iframe
          title="Badge"
          src="https://badge.zfir.dev"
          className="BadgeIframe"
          loading="lazy"
        />
      </Container>
    </Box>
  );
};

export default Badge;
